import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Pane from './pane.esm.js';
import { EMPTY_OBJECT } from '../../../utils/object.esm.js';
import { getColor, omitColor } from '../../../utils/props-utils.esm.js';
import Modal from '../../_utils/modal/modal.esm.js';

var _excluded = ["zIndex", "open", "onClose", "BackdropProps", "children", "disablePortal", "disableScrollLock", "disableBackdropClick", "useModalAsBackdrop", "modalProps", "sx", "variant"];
var ModalPane = function ModalPane(props) {
  var zIndex = props.zIndex,
    open = props.open,
    onClose = props.onClose,
    BackdropProps = props.BackdropProps,
    children = props.children,
    disablePortal = props.disablePortal,
    disableScrollLock = props.disableScrollLock,
    disableBackdropClick = props.disableBackdropClick,
    useModalAsBackdrop = props.useModalAsBackdrop,
    _props$modalProps = props.modalProps,
    modalProps = _props$modalProps === void 0 ? EMPTY_OBJECT : _props$modalProps,
    _props$sx = props.sx,
    sx = _props$sx === void 0 ? EMPTY_OBJECT : _props$sx,
    variant = props.variant,
    rest = _objectWithoutProperties(props, _excluded);
  var combinedColors = _objectSpread2(_objectSpread2({
    bg: 'white'
  }, getColor(rest)), getColor(sx));
  return /*#__PURE__*/React.createElement(Modal, _objectSpread2({
    open: open,
    onClose: onClose,
    BackdropProps: BackdropProps,
    disableBackdropClick: disableBackdropClick,
    zIndex: zIndex,
    disablePortal: disablePortal,
    disableScrollLock: disableScrollLock,
    useModalAsBackdrop: useModalAsBackdrop
  }, modalProps), /*#__PURE__*/React.createElement(Pane, _extends({}, _objectSpread2(_objectSpread2(_objectSpread2({}, combinedColors), omitColor(rest)), {}, {
    display: 'flex'
  }), {
    sx: omitColor(sx),
    variant: variant
  }), children));
};

export default ModalPane;
//# sourceMappingURL=modal-pane.esm.js.map
